import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import { Box } from '@mui/material';

import colors from '../../../../styles/colors';

const dplInputText = {
  color: colors.shades.secondary8,
  fontWeight: 400,
  fontSize: 13,
  lineHeight: '16px',
};

export const StyledDplAutoComplete = styled(Autocomplete)({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: colors.base.alpha,
    padding: '4px 8px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: colors.shades.secondary6,
  },
  '& .MuiInputBase-input': dplInputText,
});

export const DplOption = styled('li')({
  ...dplInputText,
  '&.MuiAutocomplete-option': {
    padding: '10px 12px',
  },
});

export const Card = styled('section')({
  backgroundColor: colors.base.alpha,
  border: `1px solid ${colors.shades.gamma3}`,
  borderRadius: 12,
  padding: 20,
});

export const Field = styled('div')({
  marginTop: 14,
  '&:first-of-type': { marginTop: 0 },
});

const dropzoneBorderColor = ({ hasError, dragging }) => {
  if (hasError) return colors.base.danger;
  if (dragging) return colors.base.primary;
  return colors.shades.gamma3;
};

export const Dropzone = styled('div', {
  shouldForwardProp: (prop) => prop !== 'dragging' && prop !== 'hasError',
})(({ dragging, hasError }) => ({
  border: `2px dashed ${dropzoneBorderColor({ hasError, dragging })}`,
  borderRadius: 12,
  padding: '32px 16px',
  textAlign: 'center',
  cursor: 'pointer',
  backgroundColor: dragging ? colors.shades.primary7 : colors.base.gamma,
  transition: 'background-color 120ms ease, border-color 120ms ease',
}));

export const HiddenInput = styled('input')({ display: 'none' });

export const ImageFrame = styled(Box)({
  width: '100%',
  maxWidth: 160,
  aspectRatio: '16 / 9',
  borderRadius: 8,
  overflow: 'hidden',
  marginBottom: 8,
  border: `1px solid ${colors.shades.gamma3}`,
});

export const TokenIndicator = styled('button', {
  shouldForwardProp: (prop) => prop !== 'present',
})(({ present, disabled }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  fontSize: 12,
  fontWeight: 500,
  color: present ? colors.shades.success6 : colors.shades.gamma10,
  cursor: disabled ? 'default' : 'pointer',
  background: 'transparent',
  border: 'none',
  padding: 0,
  '&:hover': { textDecoration: disabled ? 'none' : 'underline' },
}));
